// extracted by mini-css-extract-plugin
module.exports = {"holder":"CalculateButtonStyle-module--holder--3dO-i","button":"CalculateButtonStyle-module--button--vlILs"};